function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useUIDSeed } from "react-uid";
import { useScrollDirection } from "use-scroll-direction";
import { usePreviousDifferent } from "rooks";
import { twMerge } from "../../../utils";
import { CallToAction, HamburgerToggle, NavItem } from "../../atoms";
import { ArrowRight, NvisoLogo } from "../../icons";
import { LinkContext } from "../../../context";
import { NavbarMobileMenu } from "./NavbarMobileMenu";
import { Section } from "../../molecules";
export var Navbar = function(param) {
    var navItems = param.navItems, callToAction = param.callToAction, mobileSwitchLanguageAction = param.mobileSwitchLanguageAction, languageItems = param.languageItems, homeUrl = param.homeUrl, className = param.className, lines = param.lines, asFixedOverlay = param.asFixedOverlay, renderMobileHeaderLabel = param.renderMobileHeaderLabel;
    var seed = useUIDSeed();
    var navbarRef = useRef(null);
    var scrollDirection = useScrollDirection().scrollDirection;
    var ref = _slicedToArray(useState(false), 2), shouldHide = ref[0], setShouldHide = ref[1];
    var ref1 = _slicedToArray(useState(false), 2), forceOpaque = ref1[0], setForceOpaque = ref1[1];
    var previousScrollDirection = usePreviousDifferent(scrollDirection);
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var ref2 = _slicedToArray(useState(false), 2), menuOpen = ref2[0], setMenuOpen = ref2[1];
    var handleToggleMenu = useCallback(function() {
        setMenuOpen(!menuOpen);
    }, [
        menuOpen
    ]);
    useEffect(function() {
        if (typeof window !== "undefined") {
            var update = function() {
                var ref;
                var sy = document.documentElement.scrollTop || document.body.scrollTop;
                setForceOpaque(sy > 0);
                var ref1;
                setShouldHide((scrollDirection === "NONE" && previousScrollDirection === "DOWN" || scrollDirection === "DOWN") && sy >= ((ref1 = (ref = navbarRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 50));
            };
            update();
            window.addEventListener("scroll", update);
            return function() {
                return window.removeEventListener("scroll", update);
            };
        }
        return function() {};
    }, [
        scrollDirection,
        previousScrollDirection
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("nav", {
        ref: navbarRef,
        style: {
            paddingRight: "var(--removed-body-scroll-bar-size)",
            transition: "transform 150ms ease-out, background 150ms ease-out, color 150ms ease-out"
        },
        className: twMerge("top-0 left-0 duration-300 ease-out w-full", shouldHide && !menuOpen && "-translate-y-full", asFixedOverlay && "fixed text-fg-inverted", !asFixedOverlay && "sticky bg-bg-default", (forceOpaque || menuOpen) && "bg-bg-default text-fg-default", className)
    }, /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: asFixedOverlay ? false : lines,
        className: "overflow-hidden",
        contentClassName: "py-0 md:py-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid grid-cols-1 grid-rows-1 py-5 md:py-6")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-none col-start-1 row-start-1 flex items-center justify-start"
    }, /*#__PURE__*/ React.createElement(LinkComponent, {
        className: "pointer-events-auto shrink-0",
        href: homeUrl
    }, /*#__PURE__*/ React.createElement(NvisoLogo, {
        className: "block"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-none col-start-1 row-start-1 flex justify-center items-center -mx-4"
    }, navItems.map(function(item) {
        return /*#__PURE__*/ React.createElement("div", {
            key: item.href,
            className: "mx-4 pointer-events-auto hidden lg:block"
        }, /*#__PURE__*/ React.createElement(NavItem, _extends({
            key: seed(item)
        }, item), item.label));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-none col-start-1 row-start-1 flex justify-end items-center -mx-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-auto flex items-center justify-end"
    }, !!(languageItems === null || languageItems === void 0 ? void 0 : languageItems.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mx-4 group hidden grid-cols-1 grid-rows-1 lg:grid"
    }, languageItems.map(function(lang, langIndex) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _extends({
            key: lang.href
        }, lang, {
            className: twMerge("col-start-1 row-start-1 text-sm font-medium text-current transition-all duration-500", langIndex === 0 && "group-hover:-translate-y-1/2", langIndex === 1 && "group-hover:translate-y-1/2", !lang.active && "opacity-0 group-hover:opacity-100")
        }), lang.label);
    })), !!callToAction && /*#__PURE__*/ React.createElement("span", {
        className: "mx-4 hidden lg:block"
    }, /*#__PURE__*/ React.createElement(CallToAction, _extends({}, callToAction, {
        style: "button",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    }), callToAction.label))), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        "aria-label": "Menu",
        className: "pointer-events-auto mx-4 block lg:hidden",
        onClick: handleToggleMenu
    }, /*#__PURE__*/ React.createElement(HamburgerToggle, {
        isOpen: menuOpen
    })))))), /*#__PURE__*/ React.createElement(NavbarMobileMenu, {
        isOpen: menuOpen,
        navItems: navItems,
        callToAction: callToAction,
        languageSwitchAction: mobileSwitchLanguageAction,
        renderHeaderLabel: renderMobileHeaderLabel
    }));
};

//# sourceMappingURL=Navbar.js.map